var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[(_vm.value)?_c('feather-icon',{attrs:{"icon":"CalendarIcon","svgClasses":"h-5 w-5 mr-1"}}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm._f("date_format")(_vm.value, 'DD MMM YYYY HH:mm A', true, this.tenantAccountDetailsTimezone, true, ))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }